module.exports = __webpack_public_path__ + "static/img/015_TO8_1476.0c600c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/015_TO8_1476.jpg
// module id = ZNmb
// module chunks = 0